<template>
	<header></header>
</template>

<script>
    export default {
        name: 'Header',
        props: {}
    }
</script>
